export function ok(value) {
  return {
    ok: true,
    value,
    map: fn => ok(fn(value)),
    orElse: () => ok(value),
    unwrap: () => value,
    match: okCallback => okCallback(value)
  };
}
export function err(error) {
  return {
    ok: false,
    error,
    map: fn => err(fn(error)),
    orElse: fn => err(fn(error)),
    unwrap: () => error,
    match: (__, errCallback) => errCallback(error)
  };
}